import styled from 'styled-components';

import { PickActionType } from '@/core/components/PickActionType';
import { FormTextarea } from '@/core/components/FormTextarea';

export const ActionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

export const StyledPickActionType = styled(PickActionType)`
  margin: 0;
`;

export const EmailText = styled.p`
  color: #333333;
  font-size: 16px;
  line-height: 28px;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin-bottom: 1rem;
`;

interface EditableEmailTextProps {
  isEditable: boolean;
}

export const EditableEmailText = styled(EmailText)<EditableEmailTextProps>`
  ${props => props.isEditable && `
    cursor: pointer;
    text-decoration: underline;
    text-decoration-style: dashed;
    text-decoration-color: #333333;
    text-underline-offset: 0.25rem;
  `}
`;

export const SubjectText = styled.p`
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 28px;
`;

export const SignatureArea = styled.div`
  width: 100%;
  padding-top: 20px;
  font-size: 16px;
`;
